<div class="tos-container">
    <div class="tos-header">
        <div class="logo-section">
            <img [src]="'/assets/system/logo_sidebar.png'" class="logo-img" alt="Lubrikuv Logo">
        </div>

        <h1 class="tos-title">Términos y Condiciones de Suscripción</h1>
        <p class="tos-subtitle">Antes de continuar, por favor revise y acepte nuestros términos y condiciones</p>
    </div>

    <div class="subscription-summary">
        <div class="summary-card">
            <div class="summary-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                </svg>
            </div>
            <div class="summary-content">
                <div class="summary-label">Plan Seleccionado</div>
                <div class="summary-value">{{planFormateado}} <span class="period">{{intervaloPlanFormateado}}</span>
                </div>
            </div>
        </div>

        <div class="summary-card">
            <div class="summary-icon payment">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                    <line x1="1" y1="10" x2="23" y2="10"></line>
                </svg>
            </div>
            <div class="summary-content">
                <div class="summary-label">Pago vía</div>
                <div class="summary-value">{{paisID == 46 ? 'VentiPay' : 'dLocalGo'}}</div>
            </div>
        </div>
    </div>

    <div class="promo-alert" *ngIf="montoParcial != 0">
        <div class="promo-icon">🎉</div>
        <div class="promo-content">
            <strong>Cobro proporcional por primer mes</strong>
            <p>El primer mes se cobrará {{currency}} {{formatPrice(montoParcial)}} por los días restantes del período. Se cobrará el monto completo del plan seleccionado en los siguientes ciclos de facturación.
            </p>
        </div>
    </div>

    <div class="tos-content-wrapper">
        <div class="tos-content">
            <markdown [data]="md" (ready)="onMarkdownReady()"></markdown>
        </div>
    </div>
</div>

<div class="tos-footer">
    <div class="footer-content">
        <div class="acceptance-note">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
            <span>Al continuar, usted acepta los términos y condiciones de Lubrikuv</span>
        </div>

        <div class="button-group">
            <button type="button" class="btn-tos btn-reject" (click)="cancelar()">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
                Rechazar
            </button>
            <button type="button" class="btn-tos btn-accept" (click)="aceptar()">
                <span>Aceptar y Continuar</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
        </div>
    </div>
</div>